import { render, staticRenderFns } from "./ContentAreas.vue?vue&type=template&id=10110052"
import script from "./ContentAreas.vue?vue&type=script&lang=js"
export * from "./ContentAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports